module.exports = __webpack_public_path__ + "static/media/cstar_lineal.d02524a3.png";